export default __webpack_public_path__ + "static/media/html.397540de.png";